<template>
    <div class="search_nav">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="优惠券名称：">
                <el-input v-model="formInline.name" placeholder="优惠券名称"></el-input>
            </el-form-item>
            <el-form-item label="优惠券类型：">
                <el-select style="width: 150px;" v-model="formInline.type" filterable placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <!-- 1-服务费折扣 2-服务费满减 3-美式咖啡兑换券 4-冰美式咖啡兑换券 5-拿铁兑换券 6-卡布奇诺兑换券 7-摩卡兑换券 8-无糖巧克力兑换券 9-无糖巧克力牛奶兑换券 10-热牛奶兑换券 -->
                    <el-option label="服务费折扣优惠券" :value="1"></el-option>
                    <el-option label="服务费满减优惠券" :value="2"></el-option>
                    <el-option label="美式咖啡兑换券" :value="3"></el-option>
                    <el-option label="冰美式咖啡兑换券" :value="4"></el-option>
                    <el-option label="拿铁兑换券" :value="5"></el-option>
                    <el-option label="卡布奇诺兑换券" :value="6"></el-option>
                    <el-option label="摩卡兑换券" :value="7"></el-option>
                    <el-option label="无糖巧克力兑换券" :value="8"></el-option>
                    <el-option label="无糖巧克力牛奶兑换券" :value="9"></el-option>
                    <el-option label="热牛奶兑换券" :value="10"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="应用场站：">
                <el-select style="width: 150px;" v-model="formInline.stationId" filterable placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                    v-for="item in stationOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间：">
                <el-date-picker
                    v-model="formInline.dateRange"
                    type="datetimerange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="截止时间"
                    style="width: 350px;"
                />
            </el-form-item>
            <el-form-item label="启用状态：">
                <el-select style="width: 120px;" v-model="formInline.status" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已启用" :value="1"></el-option>
                    <el-option label="已停用" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <div class="button_group">
                    <el-button type="primary" @click="addCoupon">新增优惠券</el-button>
                    <!-- <el-button type="primary" @click="showRecord">发券记录</el-button> -->
                    <el-button type="primary" @click="getList">搜索</el-button>
                    <el-button type="primary" @click="refresh">刷新</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="优惠券名称" width="150" show-overflow-tooltip>
            <template #default="scope">
                <span>
                    {{ scope.row.name || '-' }}
                </span>
            </template>
        </el-table-column>
        <el-table-column label="优惠券类型" width="150">
            <template #default="scope">
                <span>{{ scope.row.typeDesc || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="面额/折扣（元）/（%）" width="180">
            <template #default="scope">
                <span>{{ checkCouponAmount(scope.row) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="门槛类别" width="150">
            <template #default="scope">
                <span>{{ scope.row.type == 1 || scope.row.type == 2 ? (scope.row.thresholdType === 1 ? '订单金额满减' : '服务费满减') : '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="使用门槛（元）" width="150">
            <template #default="scope">
                <span>{{ scope.row.useThreshold || '无门槛' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="到账有效期（天）" width="150">
            <template #default="scope">
                <span>{{ scope.row.validityType == 1 ? '永久有效' : scope.row.validityDays || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="应用场站" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.stationNames || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.createTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
            <template #default="scope">
                <el-button type="text" @click="viewDetail(scope.row)">详情</el-button>
                <el-button type="text" @click="deleteCoupon(scope.row)">删除</el-button>
                <el-button type="text" v-if="scope.row.status == 1" @click="distributeCoupon(scope.row)">派发</el-button>
            </template>
        </el-table-column>
        <el-table-column label="启用状态" width="100" fixed="right">
            <template #default="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="2"
                    @change="toggleStatus(scope.row)"
                />
            </template>
        </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 新增/编辑优惠券弹窗 -->
    <el-dialog v-model="showModal" :title="isEdit ? '编辑优惠券' : '新增优惠券'" :close-on-click-modal="false" width="600px" @closed="$refs.couponFormRef?.clearValidate()">
        <el-form :model="couponForm" :rules="couponRules" ref="couponFormRef" label-width="100px">
            <el-form-item label="优惠券名称" prop="name">
                <el-input v-model="couponForm.name" maxlength="20" placeholder="请输入优惠券名称"></el-input>
            </el-form-item>
            <el-form-item label="有效期类型" prop="validityType">
                <el-select v-model="couponForm.validityType" placeholder="请选择">
                    <el-option label="永久有效" :value="1"></el-option>
                    <el-option label="固定有效期" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="到账有效期" v-if="couponForm.validityType == 2" prop="validityDays">
                <el-input v-model="couponForm.validityDays" maxlength="3" type="number" placeholder="请输入天数" style="width: 150px;"></el-input>
                <span style="margin-left: 5px;">天</span>
            </el-form-item>
            <el-form-item label="应用场站" prop="stationIds">
                <el-select multiple clearable v-model="couponForm.stationIds" placeholder="请选择" collapse-tags collapse-tags-tooltip>
                    <el-option
                    v-for="item in stationOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <span style="margin-left: 10px; color: #999;">(已选数量{{ couponForm.stationIds.length }}个)</span>
            </el-form-item>
            <el-form-item label="优惠券类型" prop="type">
                <el-select v-model="couponForm.type" placeholder="请选择">
                    <el-option label="服务费折扣优惠券" :value="1"></el-option>
                    <el-option label="服务费满减优惠券" :value="2"></el-option>
                    <el-option label="美式咖啡兑换券" :value="3"></el-option>
                    <el-option label="冰美式咖啡兑换券" :value="4"></el-option>
                    <el-option label="拿铁兑换券" :value="5"></el-option>
                    <el-option label="卡布奇诺兑换券" :value="6"></el-option>
                    <el-option label="摩卡兑换券" :value="7"></el-option>
                    <el-option label="无糖巧克力兑换券" :value="8"></el-option>
                    <el-option label="无糖巧克力牛奶兑换券" :value="9"></el-option>
                    <el-option label="热牛奶兑换券" :value="10"></el-option>
                </el-select>
                <span v-if="couponForm.type == 1 || couponForm.type == 2" style="margin-left: 10px; color: #999;">(仅服务费优惠)</span>
            </el-form-item>
            <el-form-item v-if="couponForm.type == 1 || couponForm.type == 2" label="门槛类别" prop="thresholdType">
                <el-radio-group v-model="couponForm.thresholdType">
                    <el-radio :label="0">服务费满减</el-radio>
                    <el-radio :label="1">订单金额满减</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="couponForm.type == 1 || couponForm.type == 2" label="使用门槛" prop="useThreshold">
                <span>{{ couponForm.thresholdType === 1 ? '订单金额' : '服务费' }}满</span>
                <el-input v-model="couponForm.useThreshold" maxlength="10" type="number" placeholder="0" style="width: 100px; margin: 0 5px;"></el-input>
                <span>元可用</span>
            </el-form-item>
            <el-form-item v-if="couponForm.type == 1" label="折扣倍率" prop="discountRate">
                <el-input v-model="couponForm.discountRate" maxlength="10" type="number" placeholder=">0且≤1，保留2位小数"></el-input>
            </el-form-item>
            <el-form-item v-if="couponForm.type == 2" label="满减金额" prop="reductionAmount">
                <el-input v-model="couponForm.reductionAmount" maxlength="10" type="number" placeholder="请输入满减金额"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="showModal = false">取消</el-button>
            <el-button type="primary" @click="saveCoupon">保存</el-button>
        </template>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog v-model="showDetail" title="优惠券详情" width="500px">
        <div class="detail-content">
            <div class="detail-row">
                <span class="label">优惠券名称：</span>
                <span class="value">{{ detailData.name || '-' }}</span>
            </div>
            <div class="detail-row">
                <span class="label">优惠券类型：</span>
                <span class="value">{{ typeFormat(detailData.type) }}</span>
            </div>
            <div class="detail-row">
                <span class="label">面额/折扣：</span>
                <span class="value">{{ checkCouponAmount(detailData) }}</span>
            </div>
            <div class="detail-row">
                <span class="label">使用门槛：</span>
                <span class="value">满{{ detailData.useThreshold || '无门槛' }}元可用</span>
            </div>
            <div class="detail-row">
                <span class="label">到账有效期：</span>
                <span class="value">{{ detailData.validityType == 1 ? '永久有效' : detailData.validityDays + '天'  || '-' }}</span>
            </div>
            <div class="detail-row">
                <span class="label">应用场站：</span>
                <span class="value">{{ detailData.stationNames || '-' }}</span>
            </div>
            <div class="detail-row">
                <span class="label">创建时间：</span>
                <span class="value">{{ detailData.createTime || '-' }}</span>
            </div>
            <div class="detail-row">
                <span class="label">启用状态：</span>
                <span class="value">{{ detailData.status == 1 ? '启用' : '停用' }}</span>
            </div>
        </div>
    </el-dialog>

    <!-- 派发优惠券弹窗 -->
    <el-dialog v-model="showDistributeModal" title="派发优惠券" :close-on-click-modal="false" width="800px">
        <div class="distribute-content">
            <div class="group-section">
                <div v-for="(group, index) in distributeForm.groups" :key="index" class="group-item">
                    <span class="user-label">用户组{{ index + 1 }}:</span>
                    <el-select v-model="group.groupId" filterable placeholder="请选择用户组" style="width: 200px; margin-right: 10px;">
                        <el-option
                        v-for="item in userGroupOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <span class="label">数量</span>
                    <el-input v-model="group.count" maxlength="10" type="number" placeholder="请输入" style="width: 100px; margin-right: 5px;"></el-input>
                    <span>张</span>
                    <view class="delete-icon" @click="removeGroup(index)" v-if="distributeForm.groups.length > 1"><img src="@/assets/images/close.png" alt="删除" style="width: 20px; height: 20px;"></img></view>
                </div>
                <div class="add-group-btn">
                    <el-button type="text" @click="addGroup">+添加用户组</el-button>
                    <el-button type="primary" size="small" :loading="groupLoading" @click="confirmAddGroups">确认</el-button>
                </div>
            </div>
            <div class="user-list">
                <div v-for="(user, index) in distributeForm.users" :key="index" class="user-item">
                    <span class="user-label">用户{{ index + 1 }}:</span>
                    <span class="label">手机号</span>
                    <el-input
                        v-model="user.phone"
                        type="number"
                        maxlength="11"
                        placeholder="请输入"
                        style="width: 150px; margin-right: 10px;"
                        @blur="validateUserPhone(index)"
                    ></el-input>
                    <span class="label">数量</span>
                    <el-input v-model="user.count" maxlength="10" type="number" placeholder="请输入" style="width: 100px; margin-right: 5px;"></el-input>
                    <span>张</span>
                    <view class="delete-icon" @click="removeUser(index)" v-if="distributeForm.users.length > 1"><img src="@/assets/images/close.png" alt="删除" style="width: 20px; height: 20px;"></img></view>
                    <span v-if="user.validError" class="error-tip">请输入有效手机号</span>
                </div>
            </div>
            <div class="add-user-btn">
                <el-button type="text" @click="addUser">+添加用户</el-button>
            </div>
            <div class="remark-section">
                <span class="label required">备注:</span>
                <el-input
                    v-model="distributeForm.remark"
                    type="textarea"
                    maxlength="30"
                    placeholder="请输入派券原因"
                    :rows="3"
                    style="width: 100%;"
                />
                <span class="char-count">{{ distributeForm.remark.length }}/30</span>
            </div>
        </div>
        <template #footer>
            <el-button @click="showDistributeModal = false">返回</el-button>
            <el-button type="primary" @click="confirmDistribute">确认派发</el-button>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import { isMobileValue, required, maxLength, isNumber, isNumberValue } from '@/utils/validators';

export default {
name:'CouponManage',
data() {
    return {
        tableData: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        showModal: false,
        showDetail: false,
        showDistributeModal: false,
        isEdit: false,
        detailData: {},
        stationOptions: [],
        distributeCouponId: '',
        userGroupOptions: [],
        groupLoading: false,
        distributeForm: {
            groups: [
                { groupId: '', count: '' }
            ],
            users: [
                { userId: '', phone: '', count: '', validError: '' }
            ],
            remark: ''
        },
        formInline: {
            name: '',
            type: '',
            stationId: '',
            dateRange: [],
            status: ''
        },
        couponForm: {
            name: '',
            type: '',
            validityType: '',
            useThreshold: '',
            thresholdType: 0,
            validityDays: '',
            stationIds: [],
            discountRate: '',
            reductionAmount: ''
        },
        couponRules: {
            name: [required('请输入优惠券名称'), maxLength(20, '最多输入20个字符')],
            validityType: [required('请选择有效期类型')],
            validityDays: [required('请输入到账有效期'), isNumber('只能输入数字'), maxLength(3, '最多输入3个字符')],
            stationIds: [required('请选择应用场站')],
            type: [required('请选择优惠券类型')],
            thresholdType: [
                {
                    validator: (rule, value, callback) => {
                        if (this.couponForm.type === 1 || this.couponForm.type === 2) {
                            if (value === '' || value === null || value === undefined) {
                                callback(new Error('请选择门槛类别'));
                            } else {
                                callback();
                            }
                        } else {
                            callback();
                        }
                    },
                    trigger: 'change'
                }
            ],
            useThreshold: [
                {
                    validator: (rule, value, callback) => {
                        if (this.couponForm.type === 1 || this.couponForm.type === 2) {
                            if (!value) {
                                callback(new Error('请输入使用门槛'));
                            } else if (!isNumberValue(value)) {
                                callback(new Error('只能输入数字'));
                            } else {
                                callback();
                            }
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
            discountRate: [
                {
                    validator: (rule, value, callback) => {
                        if (this.couponForm.type === 1) {
                            if (!value) {
                                callback(new Error('请输入折扣倍率'));
                            } else {
                                const num = parseFloat(value);
                                if (isNaN(num) || num <= 0 || num > 1) {
                                    callback(new Error('折扣倍率必须大于0且小于等于1'));
                                } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                                    callback(new Error('最多保留2位小数'));
                                } else {
                                    callback();
                                }
                            }
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
            reductionAmount: [
                {
                    validator: (rule, value, callback) => {
                        if (this.couponForm.type === 2) {
                            if (!value) {
                                callback(new Error('请输入满减金额'));
                            } else {
                                callback();
                            }
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ]
        }
    }
},
mounted(){
    this.getList();
    this.getStationOptions();
},
watch: {
    '$store.state.stationList': {
        handler(newVal) {
            if (newVal && newVal.length > 0) {
                this.stationOptions = newVal;
            }
        },
        immediate: true
    }
},
methods:{
    getStationOptions(){
        let that = this;
        that.stationOptions = that.$store.state.stationList || [];
    },
    getList(){
        let that = this;
        let param = {
            page: that.currentPage,
            pageSize: that.pageSize
        };
        Object.keys(this.formInline).forEach(key => {
            if(this.formInline[key]){
                if(key === 'dateRange' && this.formInline.dateRange.length === 2){
                    param.createTimeStart = this.formInline.dateRange[0];
                    param.createTimeEnd = this.formInline.dateRange[1];
                } else if(key !== 'dateRange'){
                    param[key] = this.formInline[key];
                }
            }
        });
        that.$axios.post(that.$store.state.platformApi + "charge/coupon/page", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.tableData = result.data.records;
                that.total = result.data.total;
            }
        });
    },
    handleSizeChange(val) {
        this.pageSize = val;
        this.getList();
    },
    handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
    },
    refresh() {
        this.formInline = {
            name: '',
            type: '',
            stationId: '',
            dateRange: [],
            status: ''
        };
        this.currentPage = 1;
        this.getList();
    },
    addCoupon() {
        this.isEdit = false;
        this.couponForm = {
            name: '',
            type: '',
            validityType: '',
            useThreshold: '',
            thresholdType: 0,
            validityDays: '',
            stationIds: [],
            discountRate: ''
        };
        this.showModal = true;
    },
    saveCoupon() {
        let that = this;
        this.$refs.couponFormRef.validate((valid) => {
            if (!valid) return;
            let param = { ...that.couponForm };
            // 兑换券类型（3-10）时，使用门槛默认赋值0
            if (param.type >= 3 && param.type <= 10) {
                param.useThreshold = 0;
            }
            that.$axios.post(that.$store.state.platformApi + "charge/coupon/add", JSON.stringify(param)).then(result => {
                if(result.code == 200){
                    that.$message.success('保存成功');
                    that.showModal = false;
                    that.getList();
                }
            });
        });
    },
    viewDetail(row) {
        this.detailData = row;
        this.showDetail = true;
    },
    deleteCoupon(row) {
        let that = this;
        that.$confirm('确认删除该优惠券吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            that.$axios.post(that.$store.state.platformApi + "charge/coupon/del/"+row.id, {}).then(result => {
                if(result.code == 200){
                    that.$message.success('删除成功');
                    that.getList();
                }
            });
        });
    },
    distributeCoupon(row) {
        this.distributeCouponId = row.id;
        this.distributeForm = {
            groups: [
                { groupId: '', count: '' }
            ],
            users: [
                { userId: '', phone: '', count: '', validError: '' }
            ],
            remark: ''
        };
        this.getUserGroups();
        this.showDistributeModal = true;
    },
    getUserGroups() {
        let that = this;
        that.$axios.post(that.$store.state.platformApi + "charge/userGroup/list", {}).then(result => {
            if (result.code == 200) {
                that.userGroupOptions = result.data || [];
            }
        });
    },
    addGroup() {
        this.distributeForm.groups.push({ groupId: '', count: '' });
    },
    removeGroup(index) {
        this.distributeForm.groups.splice(index, 1);
    },
    confirmAddGroups() {
        let that = this;
        // 过滤完全未填写的行，其余行需用户组和数量填写完整
        let rows = that.distributeForm.groups.filter(g => g.groupId !== '' || g.count !== '');
        if (rows.length == 0) {
            that.$message.error('请选择用户组并输入派发数量');
            return;
        }
        for (let row of rows) {
            if (!row.groupId) {
                that.$message.error('请选择用户组');
                return;
            }
            if (!row.count || row.count <= 0) {
                that.$message.error('请输入正确的派发数量');
                return;
            }
        }
        that.groupLoading = true;
        let requests = rows.map(row => {
            return that.$axios.post(that.$store.state.platformApi + "charge/userGroup/member/list/" + row.groupId).then(result => {
                if (result.code == 200) {
                    let group = that.userGroupOptions.find(g => g.id == row.groupId);
                    // 接口返回{userId, phoneNumber}
                    return { name: group ? group.name : '', count: row.count, members: result.data || [] };
                }
                return { name: '', count: row.count, members: null };
            });
        });
        Promise.all(requests).then(results => {
            let addedCount = 0;
            let updatedCount = 0;
            let emptyGroups = [];
            let hasMembers = false;
            results.forEach(res => {
                if (!res.members || res.members.length == 0) {
                    emptyGroups.push(res.name);
                    return;
                }
                if (!hasMembers) {
                    // 添加组内用户前，先移除未填写手机号的空白行
                    that.distributeForm.users = that.distributeForm.users.filter(u => u.phone);
                    hasMembers = true;
                }
                res.members.forEach(m => {
                    if (!m.phoneNumber) return;
                    let exists = that.distributeForm.users.find(u => u.phone == m.phoneNumber);
                    if (exists) {
                        // 已在列表中的用户不重复添加，仅更新派发数量
                        if (exists.count != res.count) {
                            exists.count = res.count;
                            updatedCount++;
                        }
                    } else {
                        that.distributeForm.users.push({ userId: m.userId, phone: m.phoneNumber, count: res.count, validError: '' });
                        addedCount++;
                    }
                });
            });
            that.groupLoading = false;
            if (addedCount > 0 || updatedCount > 0) {
                that.$message.success('已从用户组添加' + addedCount + '名用户，更新' + updatedCount + '名用户数量');
                that.distributeForm.groups = [{ groupId: '', count: '' }];
            } else if (emptyGroups.length > 0) {
                that.$message.warning('用户组[' + emptyGroups.join('、') + ']暂无成员');
            } else {
                that.$message.warning('所选用户均已在列表中，派发数量未变化');
            }
        }).catch(() => {
            that.groupLoading = false;
        });
    },
    addUser() {
        this.distributeForm.users.push({ userId: '', phone: '', count: '', validError: '' });
    },
    validateUserPhone(index) {
        let that = this;
        let user = that.distributeForm.users[index];
        if (!user.phone) {
            user.validError = '';
            return;
        }
        if (!isMobileValue(user.phone)) {
            user.validError = '请输入有效手机号';
            return;
        }
        let param = [];
        param.push(user.phone);
        // 请求校验用户是否存在
        that.$axios.post(that.$store.state.platformApi + "personal/discount/users", param).then(result => {
            if (result.code == 200) {
                user.userId = result.data[0].id;
                user.validError = '';
            } else {
                user.validError = '请输入有效手机号';
            }
        }).catch(error => {
            user.validError = '请输入有效手机号';
        });
    },
    removeUser(index) {
        this.distributeForm.users.splice(index, 1);
    },
    confirmDistribute() {
        let that = this;
        // 验证用户输入
        for (let user of that.distributeForm.users) {
            if (!user.phone) {
                that.$message.error('请输入手机号');
                return;
            }
            if (!isMobileValue(user.phone) || user.validError) {
                that.$message.error('请输入正确的手机号');
                return;
            }
            if (!user.count || user.count <= 0) {
                that.$message.error('请输入正确的数量');
                return;
            }
        }
        if(that.distributeForm.remark == ''){
            that.$message.error('请输入备注');
            return;
        }
        let param = {
            couponId: that.distributeCouponId,
            users: that.distributeForm.users,
            remark: that.distributeForm.remark
        };
        that.$axios.post(that.$store.state.platformApi + "charge/coupon/dispatch", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.$message.success('派发成功');
                that.showDistributeModal = false;
                that.getList();
            }
        });
    },
    toggleStatus(row) {
        let that = this;
        that.$axios.post(that.$store.state.platformApi + "charge/coupon/status/"+row.id+"/"+row.status, {}).then(result => {
            if(result.code == 200){
                that.$message.success(row.status == 1 ? '启用成功' : '禁用成功');
                that.getList();
            }else{
                row.status = row.status == 1 ? 2 : 1;
            }
        });
    },
    showRecord() {
        // this.$router.push('/coupon-record');
    },
    typeFormat(type){
        switch(type){
            case 1:
                return '服务费折扣优惠券';
            case 2:
                return '服务费满减优惠券';
            case 3:
                return '美式咖啡兑换券';
            case 4:
                return '冰美式咖啡兑换券';
            case 5:
                return '拿铁兑换券';
            case 6:
                return '卡布奇诺兑换券';
            case 7:
                return '摩卡兑换券';
            case 8:
                return '无糖巧克力兑换券';
            case 9:
                return '无糖巧克力牛奶兑换券';
            case 10:
                return '热牛奶兑换券';
            default:
                return '-';
        }
    },
    checkCouponAmount(row){
        if(row.type == 2){
            return (row.reductionAmount || '-') + '元';
        } else if(row.type == 1){
            const rate = row.discountRate ? Math.round(row.discountRate * 100) : '-';
            return rate + '%';
        } else {
            return '-';
        }
    },
    isSpecialCoupon(type){
        return type == 4 || type == '4' || type == 5 || type == '5';
    }
}
}
</script>

<style lang="scss" scoped>
.search_nav{
    padding: 15px;
    background: #fff;
    margin-bottom: 15px;
}
.button_group{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    button{
        margin-left: 10px;
    }
}
.highlight-coupon{
    color: #e74c3c;
    font-weight: bold;
}

/* 详情弹窗样式 */
.detail-content{
    padding: 10px;
}
.detail-row{
    display: flex;
    margin-bottom: 15px;
    line-height: 28px;
}
.detail-content .label{
    font-size: 13px;
    color: #666;
    min-width: 100px;
}
.value{
    font-size: 13px;
    color: #333;
}

/* 派发优惠券弹窗样式 */
.distribute-content{
    padding: 10px;
}
.group-section{
    margin-bottom: 20px;
}
.group-item{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.add-group-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    padding: 10px;
    border: 1px dashed #ccc;
}
.user-list{
    margin-bottom: 20px;
}
.user-item{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.error-tip{
    color: #f56c6c;
    font-size: 12px;
    margin-left: 25px;
}
.delete-icon{
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
}
.user-label{
    margin-right: 10px;
    font-weight: bold;
}
.label{
    margin-right: 5px;
    color: #666;
}
.required::after{
    content: '*';
    color: #f56c6c;
    margin-left: 2px;
}
.add-user-btn{
    text-align: center;
    margin-bottom: 20px;
    padding: 10px;
    border: 1px dashed #ccc;
}
.remark-section{
    margin-top: 20px;
}
.char-count{
    display: block;
    text-align: right;
    color: #999;
    font-size: 12px;
    margin-top: 5px;
}
/* 方式一：::v-deep (Vue 2 和 Vue 3 均支持) */
::v-deep .el-input__inner[type="number"]::-webkit-outer-spin-button,
::v-deep .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep .el-input__inner[type="number"] {
  -moz-appearance: textfield;
}
</style>